import SEO from '@/components/global/SEO';
import Layout from '@/components/global/Layout';
import Servicos from '@/components/Pages/Index/Servicos';
import HeroSection from '@/components/Pages/Index/HeroSection';
import CidadesAtendidasVisita from '@/components/Pages/Index/CidadesAtendidasVisita';
import VantagensDelps from '@/components/global/VantagensDelps';
import ConhecaADelps from '@/components/global/ConhecaADelps';

import { PageWrapper, PageContainer, SectionWrapper } from '@/styles/Page';
import { VantagensWrapper, ConhecaADelpsWrapper } from '@/styles/Pages';

const IndexPage: React.FC = (): JSX.Element => {
  return (
    <>
      <SEO title="Página Inicial" description="Encurtando distâncias" />
      <Layout>
        <PageWrapper>
          <PageContainer>
            <SectionWrapper>
              <Servicos />
            </SectionWrapper>
            <SectionWrapper>
              <HeroSection />
            </SectionWrapper>
            <SectionWrapper>
              <CidadesAtendidasVisita />
            </SectionWrapper>
            <VantagensWrapper>
              <VantagensDelps />
            </VantagensWrapper>
            <ConhecaADelpsWrapper>
              <ConhecaADelps />
            </ConhecaADelpsWrapper>
          </PageContainer>
        </PageWrapper>
      </Layout>
    </>
  );
};

export default IndexPage;
